// extracted by mini-css-extract-plugin
module.exports = {"backGround":"Template_backGround__2bkxE","line":"Template_line__1d1T3","backGroundGray":"Template_backGroundGray__3c0Dh"};